<ng-container #content></ng-container>